import { css, typographyTokens } from '@salutejs/plasma-new-hope/css';

export const configH1 = {
    defaults: {
        size: 'h1',
    },
    variations: {
        size: {
            h1: css`
                ${typographyTokens.typoFontFamily}: var(--plasma-typo-h1-font-family);
                ${typographyTokens.typoFontSize}: var(--plasma-typo-h1-font-size);
                ${typographyTokens.typoFontStyle}: var(--plasma-typo-h1-font-style);
                ${typographyTokens.typoFontWeight}: var(--plasma-typo-h1-font-weight);
                ${typographyTokens.typoFontWeightBold}: var(--plasma-typo-h1-bold-font-weight);
                ${typographyTokens.typoFontWeightMedium}: var(--plasma-typo-h1-medium-font-weight);
                ${typographyTokens.typoFontLetterSpacing}: var(--plasma-typo-h1-letter-spacing);
                ${typographyTokens.typoFontLineHeight}: var(--plasma-typo-h1-line-height);
            `,
        },
    },
};
export const configH2 = {
    defaults: {
        size: 'h2',
    },
    variations: {
        size: {
            h2: css`
                ${typographyTokens.typoFontFamily}: var(--plasma-typo-h2-font-family);
                ${typographyTokens.typoFontSize}: var(--plasma-typo-h2-font-size);
                ${typographyTokens.typoFontStyle}: var(--plasma-typo-h2-font-style);
                ${typographyTokens.typoFontWeight}: var(--plasma-typo-h2-font-weight);
                ${typographyTokens.typoFontWeightBold}: var(--plasma-typo-h2-bold-font-weight);
                ${typographyTokens.typoFontWeightMedium}: var(--plasma-typo-h2-medium-font-weight);
                ${typographyTokens.typoFontLetterSpacing}: var(--plasma-typo-h2-letter-spacing);
                ${typographyTokens.typoFontLineHeight}: var(--plasma-typo-h2-line-height);
            `,
        },
    },
};
export const configH3 = {
    defaults: {
        size: 'h3',
    },
    variations: {
        size: {
            h3: css`
                ${typographyTokens.typoFontFamily}: var(--plasma-typo-h3-font-family);
                ${typographyTokens.typoFontSize}: var(--plasma-typo-h3-font-size);
                ${typographyTokens.typoFontStyle}: var(--plasma-typo-h3-font-style);
                ${typographyTokens.typoFontWeight}: var(--plasma-typo-h3-font-weight);
                ${typographyTokens.typoFontWeightBold}: var(--plasma-typo-h3-bold-font-weight);
                ${typographyTokens.typoFontWeightMedium}: var(--plasma-typo-h3-medium-font-weight);
                ${typographyTokens.typoFontLetterSpacing}: var(--plasma-typo-h3-letter-spacing);
                ${typographyTokens.typoFontLineHeight}: var(--plasma-typo-h3-line-height);
            `,
        },
    },
};
export const configH4 = {
    defaults: {
        size: 'h4',
    },
    variations: {
        size: {
            h4: css`
                ${typographyTokens.typoFontFamily}: var(--plasma-typo-h4-font-family);
                ${typographyTokens.typoFontSize}: var(--plasma-typo-h4-font-size);
                ${typographyTokens.typoFontStyle}: var(--plasma-typo-h4-font-style);
                ${typographyTokens.typoFontWeight}: var(--plasma-typo-h4-font-weight);
                ${typographyTokens.typoFontWeightBold}: var(--plasma-typo-h4-bold-font-weight);
                ${typographyTokens.typoFontWeightMedium}: var(--plasma-typo-h4-medium-font-weight);
                ${typographyTokens.typoFontLetterSpacing}: var(--plasma-typo-h4-letter-spacing);
                ${typographyTokens.typoFontLineHeight}: var(--plasma-typo-h4-line-height);
            `,
        },
    },
};
export const configH5 = {
    defaults: {
        size: 'h5',
    },
    variations: {
        size: {
            h5: css`
                ${typographyTokens.typoFontFamily}: var(--plasma-typo-h5-font-family);
                ${typographyTokens.typoFontSize}: var(--plasma-typo-h5-font-size);
                ${typographyTokens.typoFontStyle}: var(--plasma-typo-h5-font-style);
                ${typographyTokens.typoFontWeight}: var(--plasma-typo-h5-font-weight);
                ${typographyTokens.typoFontWeightBold}: var(--plasma-typo-h5-bold-font-weight);
                ${typographyTokens.typoFontWeightMedium}: var(--plasma-typo-h5-medium-font-weight);
                ${typographyTokens.typoFontLetterSpacing}: var(--plasma-typo-h5-letter-spacing);
                ${typographyTokens.typoFontLineHeight}: var(--plasma-typo-h5-line-height);
            `,
        },
    },
};
export const configH6 = {
    defaults: {
        size: 'h6',
    },
    variations: {
        size: {
            h6: css`
                ${typographyTokens.typoFontFamily}: var(--plasma-typo-h6-font-family);
                ${typographyTokens.typoFontSize}: var(--plasma-typo-h6-font-size);
                ${typographyTokens.typoFontStyle}: var(--plasma-typo-h6-font-style);
                ${typographyTokens.typoFontWeight}: var(--plasma-typo-h6-font-weight);
                ${typographyTokens.typoFontWeightBold}: var(--plasma-typo-h6-bold-font-weight);
                ${typographyTokens.typoFontWeightMedium}: var(--plasma-typo-h6-medium-font-weight);
                ${typographyTokens.typoFontLetterSpacing}: var(--plasma-typo-h6-letter-spacing);
                ${typographyTokens.typoFontLineHeight}: var(--plasma-typo-h6-line-height);
            `,
        },
    },
};
